// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Enums
import {
  adminPages,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Components
import {
  animationClass,
} from '@vroskus/library-helpers/dist/browser';
import Page from '../../layout/Page';

// Types
type $Props = $Translate;

const pageId = adminPages.notFoundPage;

const NotFoundPageView = function ({
  t,
}: $Props) {
  return (
    <Page id={pageId}>
      <div className={animationClass('fadeIn')}>
        {t('Page not found')}
      </div>
    </Page>
  );
};

export default NotFoundPageView;
